import { designTokens } from "../../constants/designTokens";

export const INK = designTokens.textPrimary;
export const INK_SOFT = designTokens.textMuted;
export const LINE = designTokens.borderLight;
export const PRIMARY = designTokens.primaryBrand;
export const PRIMARY_HOVER = designTokens.primaryHover;
export const PAGE_BG = designTokens.bgApp;
export const SURFACE = designTokens.bgSurface;
export const SUBTLE = designTokens.bgSubtle;
export const BODY_FONT = '"Source Sans 3", sans-serif';
export const DISPLAY_FONT = '"Lexend", sans-serif';

export const cardSx = {
  borderRadius: "12px",
  border: `1px solid ${LINE}`,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
  bgcolor: SURFACE,
};
